(function () {
  'use strict';
 
  var mobileToggle = document.getElementById('mobile-toggle');
  var mainNav = document.getElementById('primary-nav');
  var dropdowns = document.querySelectorAll('.has-dropdown');
 
  mobileToggle.addEventListener('click', function () {
    mainNav.classList.toggle('active');
    mobileToggle.classList.toggle('active');
  });
 
  dropdowns.forEach(function (item) {
    var link = item.querySelector(':scope > a');
    link.addEventListener('click', function (e) {
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        item.classList.toggle('open');
      }
    });
  });
 
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
  
   // Search Functionality
   var searchModal = document.getElementById('search-modal');
   var searchToggle = document.getElementById('search-toggle');
   var searchModalInput = document.getElementById('search-modal-input');
   var searchModalResults = document.getElementById('search-modal-results');
   var searchModalClear = document.getElementById('search-modal-clear');
   var searchModalClose = document.getElementById('search-modal-close');
   var searchModalLoading = document.getElementById('search-modal-loading');
   var searchIndex = [];
   var debounceTimer = null;

   var SEARCH_SYNONYMS = [
     ['anti money laundering', 'anti-money laundering', 'antimoney laundering', 'anti money', 'anti-money', 'antimoney', 'aml'],
     ['know your customer', 'know-your-customer', 'kyc'],
     ['general data protection regulation', 'gdpr'],
     ['environmental social governance', 'esg'],
     ['financial conduct authority', 'fca'],
     ['prudential regulation authority', 'pra'],
     ['sanctions', 'trade sanctions', 'financial sanctions'],
     ['bribery act', 'uk bribery act', 'bribery act 2010'],
     ['money laundering regulations', 'mlr', 'money laundering regulations 2017'],
     ['fraud act', 'fraud act 2006'],
     ['market abuse', 'market abuse regulation', 'mar'],
     ['senior managers and certification regime', 'smcr', 'sm&cr'],
     ['payment services regulations', 'psr', 'payment services'],
     ['whistleblowing', 'whistle blowing', 'whistle-blowing', 'public interest disclosure'],
     ['complaint handling', 'complaints handling', 'complaints management', 'complaint management'],
     ['competition law', 'anti-competition', 'anti competitive', 'anticompetitive'],
     ['data protection', 'data privacy', 'privacy', 'personal data'],
     ['cyber security', 'cybersecurity', 'information security', 'infosec'],
     ['conflict of interest', 'conflicts of interest', 'coi'],
     ['insider dealing', 'insider trading', 'insider dealing'],
     ['modern slavery', 'modern slavery act', 'modern slavery act 2015'],
     ['tax evasion', 'tax evasion facilitation', 'corporate criminal offences', 'cco'],
     ['treating customers fairly', 'tcf'],
     ['consumer duty', 'fca consumer duty'],
      ['financial crime', 'fincrime', 'financial crimes'],
      ['languages', 'multilingual', 'translation', 'localisation', 'internationalisation', 'internationalization'],
      ['tailored', 'bespoke', 'custom', 'customised', 'customized', 'tailored training'],
      ['analytics', 'insights', 'reporting', 'dashboard', 'metrics', 'data'],
      ['face to face', 'face-to-face', 'in person', 'in-person', 'classroom', 'workshop']
   ];

   function expandQueryWithSynonyms(query) {
     var lowerQuery = query.toLowerCase().trim();
     var queries = [lowerQuery];

     for (var i = 0; i < SEARCH_SYNONYMS.length; i++) {
       var group = SEARCH_SYNONYMS[i];
       var matched = false;
       for (var j = 0; j < group.length; j++) {
         if (lowerQuery.indexOf(group[j]) !== -1 || group[j].indexOf(lowerQuery) !== -1) {
           matched = true;
           break;
         }
       }
       if (matched) {
         for (var k = 0; k < group.length; k++) {
           if (queries.indexOf(group[k]) === -1) {
             queries.push(group[k]);
           }
         }
       }
     }

     return queries;
   }
  
  function loadSearchIndex() {
    fetch('/search_index.json')
      .then(function(response) {
        if (response.ok) return response.json();
        throw new Error('Failed to load search index');
      })
      .then(function(data) {
        searchIndex = data;
      })
      .catch(function(error) {
        console.error('Error loading search index:', error);
      });
  }
  
  function openSearchModal() {
    if (searchModal) {
      searchModal.classList.remove('closing');
      searchModal.classList.add('active');
      if (searchModalInput) {
        searchModalInput.value = '';
        setTimeout(function() { searchModalInput.focus(); }, 100);
        clearModalSearch();
      }
    }
  }
  
  function closeSearchModal() {
    if (searchModal) {
      searchModal.classList.add('closing');
      setTimeout(function() {
        searchModal.classList.remove('active');
        searchModal.classList.remove('closing');
      }, 200);
      if (searchModalInput) {
        searchModalInput.value = '';
      }
      clearModalSearch();
    }
  }
   
  function closeSearchModalAndNavigate(url) {
    closeSearchModal();
    setTimeout(function() {
      var currentPath = window.location.pathname;
      var targetPath = url.split('#')[0];
      if (currentPath === targetPath && url.indexOf('#') !== -1) {
        var hash = url.substring(url.indexOf('#'));
        var target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.location.hash = hash.substring(1);
        }
      } else {
        window.location.href = url;
      }
    }, 250);
  }
  window.closeSearchModalAndNavigate = closeSearchModalAndNavigate;
   
  function searchSuggestionClick(suggestion) {
    if (searchModalInput) {
      searchModalInput.value = suggestion;
      performSearch(suggestion);
      searchModalInput.focus();
    }
  }
  window.searchSuggestionClick = searchSuggestionClick;
  
  function clearModalSearch() {
    if (searchModalClear) {
      searchModalClear.style.display = 'none';
    }
    var statsEl = document.getElementById('search-modal-stats');
    if (statsEl) statsEl.style.display = 'none';
    if (searchModalResults) {
      searchModalResults.innerHTML = '<div class="search-modal-empty"><svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"></circle><path d="m23 23-6.5-6.5"></path></svg><p>Start typing to search across courses, articles, and pages.</p></div>';
    }
  }
  
    function scoreItemForQuery(item, lowerQuery) {
      var score = 0;

      if (item.title && item.title.toLowerCase().indexOf(lowerQuery) !== -1) {
        score += 10;
      }
      if (item.content && item.content.toLowerCase().indexOf(lowerQuery) !== -1) {
        score += 5;
      }
      if (item.summary && item.summary.toLowerCase().indexOf(lowerQuery) !== -1) {
        score += 3;
      }
      if (item.tags && item.tags.some(function(tag) { return tag.toLowerCase().indexOf(lowerQuery) !== -1; })) {
        score += 3;
      }
      if (item.categories && item.categories.some(function(cat) { return cat.toLowerCase().indexOf(lowerQuery) !== -1; })) {
        score += 3;
      }
      if (item.regulatory_coverage && item.regulatory_coverage.some(function(coverage) { return coverage.toLowerCase().indexOf(lowerQuery) !== -1; })) {
        score += 2;
      }
      if (item.search_keywords && item.search_keywords.some(function(kw) { return kw.toLowerCase().indexOf(lowerQuery) !== -1 || lowerQuery.indexOf(kw.toLowerCase()) !== -1; })) {
        score += 4;
      }

      return score;
    }

   var searchDictionary = null;
   var dictionaryBuilt = false;

   function buildSearchDictionary() {
     if (dictionaryBuilt || !searchIndex || searchIndex.length === 0) return;
     var wordMap = {};
     for (var i = 0; i < searchIndex.length; i++) {
       var item = searchIndex[i];
       var texts = [item.title || '', item.content || '', item.summary || ''];
       if (item.search_keywords) texts = texts.concat(item.search_keywords);
       if (item.tags) texts = texts.concat(item.tags);
       if (item.categories) texts = texts.concat(item.categories);
       for (var t = 0; t < texts.length; t++) {
         var words = texts[t].toLowerCase().replace(/[^a-z0-9\s'-]/g, '').split(/\s+/);
         for (var w = 0; w < words.length; w++) {
           var word = words[w].replace(/^['-]+|['-]+$/g, '');
           if (word.length >= 3) {
             wordMap[word] = (wordMap[word] || 0) + 1;
           }
         }
       }
     }
     searchDictionary = [];
     for (var key in wordMap) {
       if (wordMap.hasOwnProperty(key) && wordMap[key] >= 1) {
         searchDictionary.push(key);
       }
     }
     dictionaryBuilt = true;
   }

   function levenshteinDistance(a, b) {
     if (a.length === 0) return b.length;
     if (b.length === 0) return a.length;
     var matrix = [];
     for (var i = 0; i <= b.length; i++) matrix[i] = [i];
     for (var j = 0; j <= a.length; j++) matrix[0][j] = j;
     for (var i = 1; i <= b.length; i++) {
       for (var j = 1; j <= a.length; j++) {
         if (b.charAt(i - 1) === a.charAt(j - 1)) {
           matrix[i][j] = matrix[i - 1][j - 1];
         } else {
           matrix[i][j] = Math.min(
             matrix[i - 1][j - 1] + 1,
             matrix[i][j - 1] + 1,
             matrix[i - 1][j] + 1
           );
         }
       }
     }
     return matrix[b.length][a.length];
   }

   function getSuggestions(query) {
     if (!searchDictionary || searchDictionary.length === 0) return [];
     var words = query.toLowerCase().trim().split(/\s+/);
     var suggestions = [];
     for (var w = 0; w < words.length; w++) {
       var word = words[w];
       if (word.length < 3) continue;
       var found = false;
       for (var d = 0; d < searchDictionary.length; d++) {
         if (searchDictionary[d] === word || searchDictionary[d].indexOf(word) !== -1) {
           found = true;
           break;
         }
       }
       if (found) continue;
       var candidates = [];
       for (var d = 0; d < searchDictionary.length; d++) {
         var dictWord = searchDictionary[d];
         if (Math.abs(dictWord.length - word.length) > 2) continue;
         var dist = levenshteinDistance(word, dictWord);
         if (dist <= 2 && dist < word.length) {
           candidates.push({ word: dictWord, distance: dist });
         }
       }
       candidates.sort(function(a, b) { return a.distance - b.distance; });
       if (candidates.length > 0) {
         suggestions.push({ original: word, suggestion: candidates[0].word });
       }
     }
     if (suggestions.length === 0) return [];
     var correctedWords = words.slice();
     for (var s = 0; s < suggestions.length; s++) {
       for (var w = 0; w < correctedWords.length; w++) {
         if (correctedWords[w] === suggestions[s].original) {
           correctedWords[w] = suggestions[s].suggestion;
         }
       }
     }
     var corrected = correctedWords.join(' ');
     if (corrected !== query.toLowerCase().trim()) {
       return [corrected];
     }
     return [];
   }

    function performSearch(query) {
     if (!searchIndex || searchIndex.length === 0) {
       searchModalResults.innerHTML = '<div class="search-modal-empty"><p>Search index not available. Please refresh the page.</p></div>';
       return;
     }

     var lowerQuery = query.toLowerCase().trim();
     var allQueries = expandQueryWithSynonyms(query);
     var resultMap = {};

     for (var qi = 0; qi < allQueries.length; qi++) {
       var q = allQueries[qi];
       var isOriginal = (q === lowerQuery);
       var multiplier = isOriginal ? 1.0 : 0.8;

       for (var i = 0; i < searchIndex.length; i++) {
         var item = searchIndex[i];
         var key = item.url;
         var score = scoreItemForQuery(item, q) * multiplier;

         if (score > 0) {
           if (resultMap[key]) {
             resultMap[key].score += score;
           } else {
             resultMap[key] = { item: item, score: score };
           }
         }
       }
     }

     var results = [];
     for (var url in resultMap) {
       if (resultMap.hasOwnProperty(url)) {
         var entry = resultMap[url];
         entry.item.score = entry.score;
         results.push(entry.item);
       }
     }

      results.sort(function(a, b) { return b.score - a.score; });

     var synonymQueries = allQueries.filter(function(q) { return q !== lowerQuery; });

     displaySearchResults(results, query, synonymQueries);
   }
  
   function displaySearchResults(results, query, allQueriesForHighlight) {
    if (!searchModalResults) return;
    
    var statsEl = document.getElementById('search-modal-stats');
    var queryEl = document.getElementById('search-modal-query');
    var countEl = document.getElementById('search-modal-count');
    
    if (statsEl && queryEl && countEl) {
      queryEl.textContent = '"' + query + '"';
      countEl.textContent = results.length + (results.length === 1 ? ' result found' : ' results found');
      statsEl.style.display = 'flex';
    }
    
    if (results.length === 0) {
      buildSearchDictionary();
      var suggestions = getSuggestions(query);
      var suggestionHTML = '';
      if (suggestions.length > 0) {
        suggestionHTML = '<div class="search-suggestion"><span class="search-suggestion-label">Did you mean:</span> ' +
          suggestions.map(function(s) {
            return '<button class="search-suggestion-btn" onclick="searchSuggestionClick(\'' + escapeHTML(s).replace(/'/g, "\\'") + '\')">' + escapeHTML(s) + '</button>';
          }).join(' ') + '</div>';
      }
      searchModalResults.innerHTML = '<div class="no-results"><svg class="no-results-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"></circle><line x1="8" y1="11" x2="14" y2="11"></line></svg><h3>No results found</h3><p>Try different keywords or check your spelling.</p>' + suggestionHTML + '</div>';
      return;
    }
    
     var resultsHTML = results.map(function(result) {
       var typeLabel = result.type.charAt(0).toUpperCase() + result.type.slice(1);
       var snippet = '';
       var titleHTML = highlightText(result.title, query, allQueriesForHighlight);
       
       if (result.type === 'section' && result.parent_title) {
         titleHTML = '<span class="section-parent">' + escapeHTML(result.parent_title) + '</span> <span class="section-arrow">&rsaquo;</span> ' + titleHTML;
       }
      
      if (result.content) {
        var contentLower = result.content.toLowerCase();
        var queryLower = query.toLowerCase();
        var queryIndex = contentLower.indexOf(queryLower);

        if (queryIndex === -1 && typeof allQueriesForHighlight !== 'undefined') {
          for (var si = 0; si < allQueriesForHighlight.length; si++) {
            queryIndex = contentLower.indexOf(allQueriesForHighlight[si]);
            if (queryIndex !== -1) { queryLower = allQueriesForHighlight[si]; break; }
          }
        }

        if (queryIndex !== -1) {
          var start = Math.max(0, queryIndex - 100);
          var end = Math.min(result.content.length, queryIndex + 100);
          snippet = '...' + result.content.substring(start, end) + '...';

          var highlightTerms = [escapeRegExp(query.toLowerCase())];
          if (typeof allQueriesForHighlight !== 'undefined') {
            for (var hi = 0; hi < allQueriesForHighlight.length; hi++) {
              var escaped = escapeRegExp(allQueriesForHighlight[hi]);
              if (highlightTerms.indexOf(escaped) === -1) highlightTerms.push(escaped);
            }
          }
          var regex = new RegExp('(' + highlightTerms.join('|') + ')', 'gi');
          snippet = snippet.replace(regex, '<mark>$1</mark>');
        } else {
          snippet = result.content.substring(0, 180) + '...';
        }
      }
      
      var urlDisplay = result.url ? result.url.replace(/\/$/, '') : '';
      
      return '<div class="search-result-item" onclick="closeSearchModalAndNavigate(\'' + result.url.replace(/'/g, "\\'") + '\')"><div class="search-result-meta"><span class="search-result-type ' + result.type + '">' + typeLabel + '</span><span class="search-result-url">' + urlDisplay + '</span></div><h3 class="search-result-title"><a href="' + result.url + '" onclick="event.preventDefault();">' + titleHTML + '</a></h3>' + (snippet ? '<div class="search-result-snippet">' + snippet + '</div>' : '') + '</div>';
    }).join('');
    
    searchModalResults.innerHTML = resultsHTML;
  }
  
   function highlightText(text, query, extraTerms) {
     if (!query) return text;
     var terms = [escapeRegExp(query.toLowerCase())];
     if (extraTerms) {
       for (var i = 0; i < extraTerms.length; i++) {
         var escaped = escapeRegExp(extraTerms[i]);
         if (terms.indexOf(escaped) === -1) terms.push(escaped);
       }
     }
     var regex = new RegExp('(' + terms.join('|') + ')', 'gi');
     return text.replace(regex, '<mark>$1</mark>');
   }
  
  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
   
  function escapeHTML(string) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(string));
    return div.innerHTML;
  }
  
  // Initialize search functionality
  if (searchToggle) {
    searchToggle.addEventListener('click', openSearchModal);
  }
  
  if (searchModalClose) {
    searchModalClose.addEventListener('click', closeSearchModal);
  }
  
  if (searchModal) {
    searchModal.addEventListener('mousedown', function(e) {
      if (e.target === searchModal) {
        searchModal._closeOnMouseup = true;
      } else {
        searchModal._closeOnMouseup = false;
      }
    });
    searchModal.addEventListener('mouseup', function(e) {
      if (searchModal._closeOnMouseup && e.target === searchModal) {
        closeSearchModal();
      }
      searchModal._closeOnMouseup = false;
    });
  }
  
  if (searchModalInput) {
    searchModalInput.addEventListener('input', function(e) {
      var query = e.target.value.trim();
      
      if (searchModalClear) {
        searchModalClear.style.display = query ? 'block' : 'none';
      }
      
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        if (query) {
          performSearch(query);
        } else {
          clearModalSearch();
        }
      }, 300);
    });
    
    searchModalInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        performSearch(e.target.value);
      }
    });
    
    searchModalInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeSearchModal();
      }
    });
  }
  
    if (searchModalClear) {
      searchModalClear.addEventListener('click', function() {
        if (searchModalInput) {
          searchModalInput.value = '';
        }
        clearModalSearch();
        if (searchModalInput) {
          searchModalInput.focus();
        }
      });
    }
    
    loadSearchIndex();
    
 })();
